import { loadAppConfig } from "@/lib/app-config"

// Runtime config must be in place before any app module evaluates — the API
// client and Sentry read it at import time — so the app tree is imported
// only after /config.json settles (it resolves either way; see loadAppConfig).
await loadAppConfig()
await import("./bootstrap")
